import { useParametricSelector } from "../../../generic/redux/SelectorUtils";

import type { DocLinkSlug } from "./AllDocLinkSlugs";
import { createDocLinkUrl } from "./DocLinkUtil";

export const useDocLink = (slug: DocLinkSlug): string => useParametricSelector(createDocLinkUrl, slug);
